// extracted by mini-css-extract-plugin
export default {"headerBack":"Header_headerBack__Au01g","link":"Header_link__xJpy7"};